<h5 class="titulo">Irregularidade Empresarial</h5>

<div class="container">
  <div class="row">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>

    <div class="col-auto">
      <button class="btn btn-primary no-margin" *ngIf="podeCadastrar" type="button" [routerLink]="['/irregularidade-empresa']"
        ngbTooltip="Tela para cadastro de Irregularidade de Empresa"><i class="fa fa-file-signature">
        </i> Cadastrar nova Irregularidade
      </button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

    <div class="col-auto">
      <button #focusableSubmit type="button" class="btn btn-success no-margin" (click)="buscarTodos()">
        Pesquisar
      </button>
    </div>
  </div>

  <div class="row">

    <div class="bn-form-group col-md-5">
        <label>CNPJ da Empresa:</label>
        <input bnMask="CNPJRAIZ" class="form-control" name="cnpj" [(ngModel)]="cnpjEmpresa" >
    </div>

    <div class="bn-form-group col-md-5">
        <label>Tipo da Irregularidade:</label>
        <select id="irregularidade-empresa" class="form-select" [(ngModel)]="tipoIrregularidade">
          <option [ngValue]="undefined" selected>Todas</option>
          <option [ngValue]="tipo.codigo" *ngFor="let tipo of tipoIrregularidadeEmpresa">
            {{tipo.nome}}
          </option>
      </select>
    </div>

    <div class="bn-form-group col-md-5">
        <label>Data Inicial da Irregularidade</label>
        <bn-datepicker
            name="dataInicio"
            idInput="dataInicio"
            ngDefaultControl
            [(ngModel)]="dataInicio">
        </bn-datepicker>
    </div>

    <div class="bn-form-group col-md-5">
        <label>Data Final da Irregularidade</label>
        <bn-datepicker
            name="dataFim"
            idInput="dataFim"
            ngDefaultControl
            [(ngModel)]="dataFim">
        </bn-datepicker>
    </div>
  </div>
</div>

<app-irregularidade-empresa-listagem
  [empresa]="empresa"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  *ngIf="pesquisado"
>
</app-irregularidade-empresa-listagem>


